import * as React from 'react'
import { Badge } from '@components'
import type { ToastChipProps } from './Toast.types'
import { getToastActionType } from './Toast.utils'

const ToastChip: React.FC<ToastChipProps> = props => {
  const { variant } = props

  return (
    <Badge {...props} variant={getToastActionType(variant)} size="small">
      {props.children}
    </Badge>
  )
}

ToastChip.displayName = 'Toast.Chip'

export default ToastChip
